export interface Accordion {
  toggleOpen(): void;
  close(): void;
}

export enum AccordionState {
  CLOSED,
  OPENED
}
